var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificateSvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "certificate-svgrepo-com_1_",
    "data-name": "certificate-svgrepo-com (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23330",
    "data-name": "Path 23330",
    d: "M23,1V19H20V18h2V2H2V18h8v1H1V1ZM16,3H8V4h8ZM14,6V5H10V6ZM7,11H3v1H7Zm0,2H3v1H7ZM3,16H5V15H3Zm14-3a2,2,0,1,1-2-2,2,2,0,0,1,2,2Zm-1,0a1,1,0,1,0-1,1,1,1,0,0,0,1-1Zm0-4.293a.965.965,0,0,0,1.32.55,1.08,1.08,0,0,1,1.213.207,1.066,1.066,0,0,1,.21,1.21A.966.966,0,0,0,19.293,12a1.064,1.064,0,0,1,0,2,.965.965,0,0,0-.549,1.323A1.05,1.05,0,0,1,18,16.816v7.046l-3-2.538-3,2.538V16.816a1.05,1.05,0,0,1-.744-1.49A.965.965,0,0,0,10.707,14a1.064,1.064,0,0,1,0-2,.966.966,0,0,0,.549-1.324,1.066,1.066,0,0,1,.209-1.21,1.08,1.08,0,0,1,1.212-.206A.965.965,0,0,0,14,8.707a1.064,1.064,0,0,1,2.005,0Zm1,13v-5.04a.93.93,0,0,0-1,.625,1.064,1.064,0,0,1-2,0,.93.93,0,0,0-1-.625v5.039l2-1.692Zm-1.94-4.749a1.967,1.967,0,0,1,1.853-1.308,2.12,2.12,0,0,1,.87.2l.058-.091a1.964,1.964,0,0,1,1.116-2.695v-.122a1.966,1.966,0,0,1-1.116-2.695l-.087-.084A1.965,1.965,0,0,1,15.06,9.043h-.12a1.965,1.965,0,0,1-2.694,1.117l-.087.084a1.966,1.966,0,0,1-1.116,2.695v.122a1.964,1.964,0,0,1,1.116,2.695l.058.09a2.12,2.12,0,0,1,.87-.2,1.967,1.967,0,0,1,1.853,1.308L15,17Z",
    fill: "#642d92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23331",
    "data-name": "Path 23331",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateSvgrepoCom1);
export default __webpack_public_path__ + "static/media/certificate-svgrepo-com (1).7f5cb839674ef10250f5fb3551005a67.svg";
export { ForwardRef as ReactComponent };